import React from 'react';

export const NoAccess: React.FC = () => {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-surface overflow-hidden">
      {/* Ambient gradient blobs */}
      <div className="absolute -top-[20%] -left-[10%] w-[60%] h-[60%] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />
      <div className="absolute -bottom-[20%] -right-[10%] w-[50%] h-[50%] bg-[#007bba]/5 blur-[100px] rounded-full pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-md px-4">
        <div className="bg-surface-container-low rounded-xl p-8 space-y-6 shadow-2xl">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-surface-container-highest">
              <span
                className="material-symbols-outlined text-on-surface-variant text-4xl"
                style={{ fontVariationSettings: "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24" }}
              >
                lock
              </span>
            </div>
          </div>

          {/* Title & description */}
          <div className="text-center space-y-2">
            <h2 className="text-xl font-bold text-on-surface">Access Denied</h2>
            <p className="text-sm text-on-surface-variant leading-relaxed">
              You need administrator permissions to access the template manager.
            </p>
          </div>

          {/* Divider */}
          <div className="border-t border-outline-variant/20" />

          {/* Help section */}
          <div className="flex items-start gap-3 bg-surface-container-lowest rounded-lg p-4">
            <span className="material-symbols-outlined text-on-surface-variant/60 text-xl mt-0.5">
              help_outline
            </span>
            <div className="space-y-1">
              <p className="text-xs font-medium text-on-surface-variant">Need access?</p>
              <p className="text-[11px] text-on-surface-variant/60 leading-relaxed">
                Contact your server administrator to request administrator permissions for this guild.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
